/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './site-dashboard-widget.scss';

/* eslint-disable import/no-unresolved, import/default */

import siteDashboardWidgetTemplate from './site-dashboard-widget.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siteDashboardWidget', [])
    .directive('agSiteDashboardWidget', SiteDashboardWidget)
    .name;

/*@ngInject*/
function SiteDashboardWidget() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            siteId: '='
        },
        controller: SiteDashboardWidgetController,
        controllerAs: 'vm',
        templateUrl: siteDashboardWidgetTemplate
    };
}

/*@ngInject*/
function SiteDashboardWidgetController($scope, siteService, agTypes, types) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.loading = true;

    vm.siteColor = siteColor;
    vm.siteStatusText = siteStatusText;

    $scope.$watch('vm.siteId', function() {
        vm.site = null;
        loadSite();
    });

    function loadSite() {
        vm.site = null;
        if (vm.siteId) {
            vm.loading = true;
            siteService.getSite(vm.siteId, true).then(
                function success(site) {
                    vm.site = site;
                    vm.loading = false;
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function siteColor() {
        if (vm.site && vm.site.highestAlarmSeverity === 'CRITICAL') {
            if (vm.site.highestAlarmStatus === types.alarmStatus.activeUnack) {
                return agTypes.colors.errorColor;
            }
            return agTypes.colors.normalGreyColor;
        } else {
            return agTypes.colors.normalColor;
        }
    }

    function siteStatusText() {
        if (vm.site && vm.site.highestAlarmSeverity === 'CRITICAL') {
            if (vm.site.highestAlarmStatus === types.alarmStatus.activeUnack) {
                return 'ag.site.status-alarms';
            }
            return 'ag.site.status-alarms-stale';
        } else {
            return 'ag.site.status-normal';
        }
    }
}
